import { styled } from '@mui/material';

export const MessageWrapper = styled('div')(({ theme }) => ({
  paddingTop: 16,
  textAlign: 'center',
  fontSize: '16px',
  color: '#BBB',
  fontWeight: 'normal',
  lineHeight: 1.5,
  [theme.breakpoints.up('sm')]: {
    paddingRight: 200,
    paddingLeft: 200,
  },
  [theme.breakpoints.down('sm')]: {
    paddingRight: 40,
    paddingLeft: 40,
  },
}));

export const NoCardWrapper = styled('div')(({ theme }) => ({
  backgroundColor: '#0f0f0f',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '48px 48px',
  margin: '48px 0px',
  [theme.breakpoints.down('xl')]: {
    padding: '40px 40px',
    margin: '40px 0px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '32px 32px',
    margin: '32px 0px',
  },
}));
